import axios from "axios";
import { useEffect, useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import { root_url } from "../setting";
//결제 확인 및 주의사항
const PayComplete = ({ payCompleteInfo, history }) => {
  //http://localhost:8080/success?joinerName=%EC%9A%B0%ED%9E%8C%EC%9A%B0&orderName=%EA%B3%84%EC%A1%B1%EC%82%B0%EC%84%B1%EA%B8%B8(7km)%20%EC%99%B8%202%EA%B1%B4&orderId=1627049786716&paymentKey=vG45eDbZnodP9BRQmyarYk65EvM5Z3J07KzLNkE6AOMwXYWl&amount=10000
  //joinerName, orderName, joinseq, amount만 있어도 됨
  //진입시, 카드결제인 경우, joiner 결제상태 CMPL로 업데이트해줘야함
  //결제 시간이 만료되면 404 error가 뜬다(이것도 인지해야함)
  const [applicant, setApplicant] = useState({});
  const [runnersByTicketType, setRunnersByTicketType] = useState({});
  const [cookies, getCookie] = useCookies(["orderIdCookie"]);
  console.log(cookies.orderId);
  let query = new URLSearchParams(useLocation().search);
  const joinSeq = query.get("joinSeq");
  const joinHash = query.get("joinHash");

  useEffect(() => {
    // console.log("joinHash: " + joinHash);
    // console.log("저장된 cookies:" + cookies.orderIdCookie);
    if (joinHash === cookies.orderIdCookie) {
      axios({
        method: "get",
        url: `${root_url}/api/applicant/complete?joinSeq=${joinSeq}`,
      })
        .then((res) => {
          // console.log(res.data);
          setApplicant(res.data.applicant);
          setRunnersByTicketType(res.data.runnersByTicketType);
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      // 
    }
  }, []);
  return (
    <Container className="mb-4">
      {applicant.joinSeq !== undefined ? (
        <div>
          <h3 className="text-custom-color mt-3">결제 확인 및 주의사항</h3>
          <p>
            <span style={{ fontWeight: "bold" }}>
              접수번호
              {applicant.joinSeq}번{" "}
            </span>
            {applicant.joinerName}님의 참가신청이 정상적으로 접수되었습니다.{" "}
            <span className="text-danger">
              접수번호는 신청 조회 및 수정에 반드시 필요합니다.
            </span>
          </p>
          <h5 className="text-custom-color">· 조회 및 수정시, 필요한 정보</h5>
          <Table style={{ lineHeight: "2.5rem", marginLeft: "1rem" }}>
            <tr>
              <td style={{ width: "15%" }}>이름</td>
              <td>{applicant.joinerName}</td>
            </tr>
            <tr>
              <td>전화번호</td>
              <td>{applicant.cellphone}</td>
            </tr>
            <tr>
              <td>접수번호</td>
              <td>{applicant.joinSeq}</td>
            </tr>
          </Table>
          {runnersByTicketType.online && (
            <Row>
              <Col
                xs={12}
                lg={3}
                className="ms-4 ms-lg-0 mt-5 text-custom-color"
              >
                <h4>언텍트 마라톤</h4>
              </Col>
              <Col>
                <UntactMar
                  applicant={applicant}
                  runnersByTicketType={runnersByTicketType}
                />
              </Col>
            </Row>
          )}
          {runnersByTicketType.offline && (
            <Row>
              <Col
                xs={12}
                lg={3}
                className="ms-4 ms-lg-0 mt-5 text-custom-color"
              >
                <h4>마라톤(하프 / 미니 / 건강)</h4>
              </Col>
              <Col>
                <Offline
                  applicant={applicant}
                  runnersByTicketType={runnersByTicketType}
                />
              </Col>
            </Row>
          )}
          {runnersByTicketType.trekking && (
            <Row>
              <Col
                xs={12}
                lg={3}
                className="ms-4 ms-lg-0 mt-5 text-custom-color"
              >
                <h4>언텍트 트레킹</h4>
              </Col>
              <Col>
                <Trekking
                  applicant={applicant}
                  runnersByTicketType={runnersByTicketType}
                />
              </Col>
            </Row>
          )}
        </div>
      ) : (
        <div>
          <h3 className="mt-5">세션이 만료되었습니다.</h3>
          <p className="m-4">
            올바르지 않은 접근이거나, 시간이 지나 세션이 만료되었습니다. 다시
            신청 조회를 해주시기 바랍니다.
          </p>
        </div>
      )}
    </Container>
  );
};
export default PayComplete;

const UntactMar = ({ applicant, runnersByTicketType }) => {
  return (
    <div className="mt-2 mb-2 mt-lg-5 mb-lg-5">
      <Container className="mb-5">
        <h3>배번호 및 전자칩 수령방법</h3>
        <div>
          <div>
            <p>전용앱이나 홈페이지에서 다운받아 인쇄</p>
            <p>결제가 완료된 상태에서만 가능합니다! (현재 배번호 출력 불가)</p>
          </div>
        </div>
      </Container>
      {applicant.paymentStatus === "RSVT" && (
        <Container className="mb-5">
          <h3>참가비 입금 방법</h3>
          <p>언텍트M(18km) : 10000원</p>
          <p>
            온라인 입금의 경우, 지정통장에 신청자명+전화번호 4자리
            <span className="fw-bold">
              ({applicant.paymentType === "BANK" && applicant.brief})
            </span>
            으로 입금하여 주시기 바랍니다. 상이할 경우 사무국으로 반드시 연락을
            주시기 바랍니다.
          </p>
          <p>입금계좌: 하나은행 654-910058-91905</p>
          <p>예금주: 대전광역시 대덕구체육회</p>
        </Container>
      )}
      <Container className="mb-5">
        <h3>참가확인</h3>
        <div>
          <div>
            <p>홈페이지 참가신청조회에서 확인하시기 바랍니다.</p>
            <p>
              온라인으로 송금하신 분들은 입금 다음날 홈페이지에서 입금확인을
              하시기 바랍니다.
            </p>
            <p className="text-custom-color" style={{ fontSize: "0.9rem" }}>
              본 회에서는 온라인 입금확인을 은행업무 종료 후 일괄 체크합니다.
            </p>
          </div>
        </div>
      </Container>
      <Container className="mb-5">
        <h3>유의사항</h3>
        <p>접수기간 이후에는 참가비가 환불되지 않습니다.</p>
        <p>(참가 신청 후 참가비 납부 후 취소시, 코스변경에 따른 참가비 등)</p>
        <p>반드시 전용 앱 설치 후 대회에 참여하여 주시기 바랍니다.</p>
      </Container>
    </div>
  );
};
const Offline = ({ applicant, runnersByTicketType }) => {
  return (
    <div className="mt-2 mb-2 mt-lg-5 mb-lg-5">
      <Container className="mb-5">
        <h3>배번호 및 전자칩 수령방법</h3>
        <div>
          <div>
            <p>대회전 입력한 주소지로 택배 발송</p>
          </div>
        </div>
      </Container>
      {applicant.paymentStatus === "RSVT" && (
        <Container className="mb-5">
          <h3>참가비 입금 방법</h3>
          <p>하프 코스 : 35,000원</p>
          <p>미니 코스 : 35,000원</p>
          <p>건강 코스 : 20,000원</p>
          <p>
            온라인 입금의 경우, 지정통장에 신청자명+전화번호 4자리
            <span className="fw-bold">
              ({applicant.paymentType === "BANK" && applicant.brief})
            </span>
            으로 입금하여 주시기 바랍니다. 상이할 경우 사무국으로 반드시 연락을
            주시기 바랍니다.
          </p>
          <p>입금계좌: 하나은행 654-910058-91905</p>
          <p>예금주: 대전광역시 대덕구체육회</p>
        </Container>
      )}
      <Container className="mb-5">
        <h3>참가확인</h3>
        <div>
          <div>
            <p>홈페이지 참가신청조회에서 확인하시기 바랍니다.</p>
            <p>
              온라인으로 송금하신 분들은 입금 다음날 홈페이지에서 입금확인을
              하시기 바랍니다.
            </p>
            <p className="text-custom-color" style={{ fontSize: "0.9rem" }}>
              본 회에서는 온라인 입금확인을 은행업무 종료 후 일괄 체크합니다.
            </p>
          </div>
        </div>
      </Container>
      <Container className="mb-5">
        <h3>유의사항</h3>
        <p>접수기간 이후에는 참가비가 환불되지 않습니다.</p>
        <p>(참가 신청 후 참가비 납부 후 취소시, 코스변경에 따른 참가비 등)</p>
      </Container>
    </div>
  );
};
const Trekking = ({ applicant, runnersByTicketType }) => {
  return (
    <div className="mt-2 mb-2 mt-lg-5 mb-lg-5">
      <Container className="mb-5">
        <h3>참가확인</h3>
        <div>
          <div>
            <p>홈페이지 참가신청조회에서 확인하시기 바랍니다.</p>
          </div>
        </div>
      </Container>
      <Container className="mb-5">
        <h3>유의사항</h3>
        <p>반드시 전용 앱 설치 후 대회에 참여하여 주시길 바랍니다.</p>
      </Container>
    </div>
  );
};
